import clsx from 'clsx'
import isEmpty from 'lodash/isEmpty'
import React, { FC, useMemo } from 'react'

import { BlockContainer } from '@Components/BlockContainer'
import { Title } from '@Components/CMS/Title'
import { ProductSlider as ProductSliderV2 } from '@Domains/Product/Features/ProductSlider/ProductSlider'
import { ProductSliderBlock as ProductSliderBlockGraphQL } from '@Generated/graphql'
import { useBlockConfig } from '@Globals/CMS/Context'

import styles from './ProductSliderBlock.module.scss'

export interface ProductSliderBlockData {
  id?: string
  productSliderBlock: ProductSliderBlockGraphQL
}

const getBlockData = ({
  filter,
  filters,
  header,
  id,
  limit,
}: ProductSliderBlockGraphQL) => ({
  filters: filters || filter || '',
  id,
  limit: Number(limit),
  title: header,
})
const ProductSliderBlock: FC<ProductSliderBlockData> = ({
  id,
  productSliderBlock,
}) => {
  const config = useBlockConfig()
  const data = useMemo(() => getBlockData(productSliderBlock), [productSliderBlock])
  if (productSliderBlock.appearance && productSliderBlock.common && !isEmpty(productSliderBlock.common.title)) {
    const { appearance, common } = productSliderBlock
    const products = config?.algolia?.hitsArray || []
    return (
      <BlockContainer
        appearance={appearance || {}}
        common={common || {}}
        id={id}
      >
        <ProductSliderV2
          className={styles.slider}
          hideBuyButtons={false}
          id={id}
          products={products}
          skipReset
          style={{ thumbColor: appearance?.textColor || undefined }}
          withoutSuccessPrompt={false}
        />
      </BlockContainer>
    )
  }

  return (
    <ProductSliderV2
      className={clsx(styles.productSlider)}
      header={<Title title={data.title || ''} type="h4" />}
      hideBuyButtons={false}
      id={id}
      products={(config?.algolia?.hitsArray || [])}
      skipReset
      withoutSuccessPrompt={false}
    />
  )
}

export default ProductSliderBlock
